import React from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SelectMenuComponent from '../../../../../../common/react/components/select-menu';

export default class StripePayment extends React.Component {
	constructor (props) {
		super(props);

		let settings = this.props.formData.settings;
		let savedStripeAccountEmail = "";

		this.connectedAccounts = [];

		if (window.edlio.stripeAccounts) {
			this.connectedAccounts = JSON.parse(window.edlio.stripeAccounts);
		}

		this.activeAccounts = [];
		this.inactiveAccounts = [];

		this.connectedAccounts.map(acc => {
			if (acc.metadata.edlioActive == 0) {
				this.inactiveAccounts.push(acc);
			} else {
				this.activeAccounts.push(acc);
			}
		});

		if (this.activeAccounts) {
			let emailArray = [];

			this.activeAccounts.forEach(function(account) {
				emailArray.push(account.email);
			});

			savedStripeAccountEmail = settings[FormSettings.STRIPE_ACCOUNT] ? settings[FormSettings.STRIPE_ACCOUNT].email : "";

			if (emailArray.indexOf(savedStripeAccountEmail) == -1) {
				savedStripeAccountEmail = Defaults.NO_ACCOUNT;
			}
		} else {
			savedStripeAccountEmail = Defaults.NO_ACCOUNT;
		}

		this.state = {
            selectedAccount: savedStripeAccountEmail
        };
	}

	getStripeAccountEmails() {
		let stripeLabels = [];
		if (this.activeAccounts.length) {
		    stripeLabels.push({
                label: Defaults.NO_ACCOUNT,
                callback: () => {
                    this.setState({selectedAccount: Defaults.NO_ACCOUNT}, () => {
                        this.props.updateCallback(FormSettings.STRIPE_ACCOUNT, {});
                    })
                }
            });

			for (let i=0; i<this.activeAccounts.length; i++) {
				stripeLabels.push({
					label: this.activeAccounts[i].email,
					callback: () => {
						this.setState({selectedAccount: this.activeAccounts[i].email}, () => {
							this.props.updateCallback(FormSettings.STRIPE_ACCOUNT, {email: this.activeAccounts[i].email, id: this.activeAccounts[i].id});
						});
					}
				});
			}
		}
		return stripeLabels;
	}

	render() {

		let { localization } = this.props;

		return (
            <section>
                <p>
                    {localization.substitute('Forms with payments can be used to sell tickets, collect fees, and ask for donations.')}
                    {localization.substitute('You are responsible for complying with all applicable tax laws.')}
                </p>
                <div className={`stripe-account-selection`}>
                    <h3>
                        Deposit Account
                    </h3>
                    {
                        window.edlio.isAdmin ? (<span className={"note"}>{localization.substitute('Connect accounts in')} <a href="/apps/settings/admin_index.jsp?tid=31">{localization.substitute('Settings')}</a></span>)
                        : (<span className={"note"}>{localization.substitute('Website administrators can manage accounts in Settings')}</span>)
                    }
                    <br/>
                    <SelectMenuComponent
                        additionalClasses={this.activeAccounts.length ? null : 'disabled'}
                        options={this.getStripeAccountEmails()}
                        selectedOption={this.state.selectedAccount}
                    />
                </div>
            </section>
		);
	}

}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/stripe-payment.js